module.exports = __webpack_public_path__ + "static/media/application_form.360432ed.docx";